<template>
    <div :class="classes" @click="handleClick">
        <v-font-icon v-if="isChecked" :class="theme.isChecked">check_box</v-font-icon>
        <v-font-icon v-else>check_box_outline_blank</v-font-icon>
    </div>
</template>
<script>
    import { vFontIcon } from '../FontIcon';
    import theme from './checkbox.scss';

    export default {
        name: 'checkbox-raw',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            value: {
                type: Array,
                default() {
                    return [];
                }
            },
            data: {
                type: [
                    String,
                    Number,
                    Boolean,
                    Object // { id: Number, ... }
                ],
                default: true,
            },
        },
        components: {
            vFontIcon,
        },
        computed: {
            classes() {
                return {
                    [theme.checkboxControl]: true,
                    [theme.isChecked]: this.isChecked,
                }
            },
            isChecked() {
                return this.value.find((item) => {
                    if(typeof(this.data) !== 'object'){
                        return item === this.data
                    }
                    else {
                        return item.id === this.data.id
                    }
                }) !== undefined;
            }
        },
        methods: {
            handleClick() {
                this.$emit('input', this.isChecked
                    ? this.value.filter((item) => {
                        if(typeof(this.data) !== 'object'){
                            return item !== this.data
                        }
                        else {
                            return item.id !== this.data.id
                        }
                    })
                    : this.value.concat([this.data])
                );
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CheckboxRaw.vue?1588f801